<div class="fgbcl-game-predictor-unsave-modal-title">Are you sure?</div>
<hr _ngcontent-ng-c1411465786="" class="horizontal-line" />
<div class="fgbcl-game-predictor-unsave-modal-description">
  {{ 'fgbcl.game.predictor.unsaved.warning.text' | translate }}
</div>
<hr _ngcontent-ng-c1411465786="" class="horizontal-line" />
<div class="fgbcl-game-predictor-unsave-modal-footer">
  <button
    type="button"
    class="fgbcl-game-predictor-unsave-modal-btn fgbcl-game-predictor-unsave-modal-cancel-btn"
    (click)="onCancel()"
  >
    Cancel
  </button>
  <button
    type="button"
    class="fgbcl-game-predictor-unsave-modal-btn fgbcl-game-predictor-unsave-modal-confirm-btn"
    (click)="onConfirm()"
  >
    Confirm
  </button>
</div>
